import { render, staticRenderFns } from "./OneTimeCode.vue?vue&type=template&id=52030d18&scoped=true"
import script from "./OneTimeCode.vue?vue&type=script&lang=js"
export * from "./OneTimeCode.vue?vue&type=script&lang=js"
import style0 from "./OneTimeCode.vue?vue&type=style&index=0&id=52030d18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52030d18",
  null
  
)

export default component.exports